import { useEffect } from "react";

import { useContainer } from "@contexts/container-context";
import { useCurrentUser } from "@queries/account";
import { useRole } from "@queries/account-selectors";

export function useAppcuesSync() {
  const currentUser = useCurrentUser();
  const roleId = useRole();
  const { appcuesService } = useContainer();

  useEffect(() => {
    if (currentUser && roleId) {
      const { email, firstName, lastName, userId, organizationCode } =
        currentUser;
      const userProperties = { roleId, email, firstName, lastName };

      appcuesService.identify(userId, userProperties);

      if (organizationCode) {
        appcuesService.group(organizationCode);
      }
    } else {
      appcuesService.reset();
    }
  }, [currentUser, roleId]);
}
